import "./intro";
import "./publication/publications";
import "./about";
import "./about-double";
import "./features";
import "./news";
import "./projects";
import "./partners";
import "./tabs";
import "./history/history-tiny-slider";
import "./graduates";
import "./documents";
import "./types-diplomas";
import "./admission-deadlines";
import "./article";
import "./article-news";
import "./program-profiles";
import "./students-section";
import "./television";
import "./magazines";
import "./filter-publications/filter-publications";
import "./actual-info/actual-info";
import "./program-documents";
import "./program-feedback";
import "./program-courses";
import "./program-other-areas";
import "./collaboration";
import "./regular";
import "./science-events/science-events";
import "./student-projects-slider";
import "./info-tags";
import "./licenses";
import "./programs";
import "./departments";
import "./slides-modal";
